const setAjudaNav = () => {
  const items = document.querySelectorAll('.ajuda-item');
  if (!items.length) return;

  items?.forEach((item) => {
    item?.addEventListener('click', () => {
      items?.forEach((i) => i?.classList.remove('-active'));
      item?.classList.add('-active');
    });
  });
};

export default setAjudaNav;
